
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "airport",
  "use": "airport-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"airport\"><path d=\"M24.152.008V0c-.051 0-.101.003-.152.003-.05 0-.1-.003-.152-.003v.008C13.535.172 5.225 8.578 5.225 18.928 5.225 32.878 21.602 46.12 24 48c2.398-1.88 18.775-15.122 18.775-29.072 0-10.35-8.31-18.756-18.623-18.92z\" /><path d=\"M34.039 14.863l-3.826 3.58 3.447 11.516-1.93 1.931a.543.543 0 01-.767 0l-5.14-9.34-4.727 4.662.754 3.674-1.204 1.203a.408.408 0 01-.578 0l-6.808-6.808a.408.408 0 010-.578l1.204-1.204 3.606.736 4.664-4.745-9.275-5.104a.543.543 0 010-.767l1.93-1.93 11.44 3.424 3.605-3.854c1.054-1.053 2.714-1.1 3.709-.105.996.995.95 2.656-.104 3.71z\" fill=\"#fff\" /></symbol>"
});
    sprite.add(symbol);

    export default class AirportSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="airport" {...this.props} />;
      }
    }
  